import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';

import styled, { tstyled } from '../theme';
import { FooterRenderer, IRenderProps } from '../models/Footer';
import DiscoDudeFooter from '../assets/disco-dude-footer.svg';

interface IProps {
  peach?: boolean;
}

const Container = tstyled<IProps>(styled.div)`
  display: none;
  background-color: ${(props) => (props.peach ? '#f0c491' : 'transparent')};

  a {
    color: ${(props) => props.theme.color.body2};
    text-decoration: underline;
    display: inline-block;

    &:hover {
      transform: scaleY(-1);
    }
  }

  @media (min-width: ${(props) => props.theme.aboutBreakpoint}px) {
    display: block;
  }
`;

const Inner = tstyled<IProps>(styled.div)`
  padding: 60px 0;
  border-top: 1px solid ${(props) =>
    props.peach ? props.theme.color.body2 : '#ebebeb'};
  width: 65%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
`;

const Column = styled.div`
  width: 190px;
  line-height: 1.5;
  font-size: 12px;
  color: ${(props) => props.theme.color.body2};

  > * {
    height: 40px;
    display: flex;

    &:nth-child(2n) {
      justify-content: flex-end;
      flex-direction: column;
    }
  }

  @media (min-width: 1800px) {
    font-size: 0.8vw;
    width: 10vw;
    > * {
      height: 3.2vw;
    }
  }
`;

const ImageContainer = tstyled<IProps>(styled.div)`
  margin-top: 28px;
  width: 2.8vw;
  padding-bottom: 22.5%;
  background-position: left top;
  background-repeat: no-repeat;
  background-blend-mode: multiply;
  background-color: ${(props) => (props.peach ? '#f0c491' : 'transparent')};
`;

function Footer(props: IRenderProps & IProps) {
  const {
    data: { fields },
  } = props;

  return (
    <Container peach={props.peach}>
      <Inner peach={props.peach}>
        <Column>
          <ReactMarkdown
            source={fields.employmentStatus}
            renderers={{
              link: (p) => {
                if (!p.href.startsWith('http')) {
                  return p.href;
                }

                return (
                  <a
                    href={p.href}
                    rel="nofollow noreferrer noopener"
                    target="_blank"
                  >
                    {p.children}
                  </a>
                );
              },
            }}
          />
          <div>
            <div>
              <Link to="/about">About Troy Curtis Kreiner</Link>
            </div>
          </div>
          <Link to="/egg" style={{ display: 'block' }}>
            <ImageContainer
              peach={props.peach}
              style={{ backgroundImage: `url(${DiscoDudeFooter})` }}
            />
          </Link>
        </Column>
        <Column>
          <div>{fields.currentLocation}</div>
          <div>
            <div>
              {fields.emailTitle}
              <a href={`mailto:${fields.email}`}>{fields.email}</a>
            </div>
          </div>
        </Column>
        <Column>
          <div>{fields.phoneNumber}</div>
          <div>
            <div>
              <a
                href={fields.facebook}
                rel="noopener noreferrer nofollow"
                target="_blank"
              >
                {/* 
                  TODO: CMS model is coupled to specific social names. 
                  To allow this to be more flexible in the future, these should
                  be pulled from a relation list.
                */}
                Are.na
              </a>
              ,{' '}
              <a
                href={fields.instagram}
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                Instagram
              </a>
              ,{' '}
              <a
                href={fields.linkedIn}
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                LinkedIn
              </a>
              <br />
              <a
                href={fields.cv.fields.file.url}
                rel="noopener noreferrer nofollow"
                target="_blank"
              >
                Download CV
              </a>
            </div>
          </div>
        </Column>
      </Inner>
    </Container>
  );
}

export default function Wrapper(props: IProps) {
  return <FooterRenderer render={Footer} {...props} />;
}



// WEBPACK FOOTER //
// ./src/components/FooterDesktop.tsx